<!--
 * @Description: 墨源碳材料库
 * @Author: ywz
 * @Date: 2025-07-15
 -->
 <template>
  <div>
    <el-form class="table-search-bar"
             :model="searchForm"
             ref="searchForm"
             inline
             label-width="100px">
      <el-form-item label="预警类型"
                    prop="forewarningType">
        <el-select v-model="searchForm.forewarningType"
                   clearable
                   filterable>
          <el-option v-for="item in warningTypeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="handleSearch"
                   icon="el-icon-search">查 询</el-button>
        <el-button type="primary"
                   @click="reset">重 置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="warningLedgerList"
              style="width: 100%"
              tooltip-effect="light">
      <el-table-column prop="reservoirAreaCode"
                       label="库区编码"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="reservoirAreaName"
                       label="库区名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="forewarningType"
                       label="预警类型"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="forewarningTime"
                       label="预警时间"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="takeOrderNo"
                       label="提货单号"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="carNo"
                       label="车号"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="reason"
                       label="预警原因"
                       :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="listState.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="listState.total"
                   background>
    </el-pagination>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'warningLedger',
  components: {
  },
  data () {
    return {
      searchForm: {},
      warningTypeOptions: [
      ],
      pageNo: 1,
      pageSize: 100
    }
  },
  computed: {
    ...mapState({
      warningLedgerList: (state) => state.warningLedger.list,
      listState: (state) => state.warningLedger.listState
    })
  },
  mounted () {
    this.handleSearch()
    this.getWarningTypeOptions().then(res => {
      if (res && res.data) {
        const tempArr = []
        Object.keys(res.data).forEach(key => {
          tempArr.push({ label: res.data[key], value: key })
        })
        this.warningTypeOptions = tempArr
      }
    })
  },
  methods: {
    ...mapActions(['getWarningLedgerList', 'getWarningTypeOptions']),
    reset () {
      this.$refs['searchForm'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getWarningLedgerList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getWarningLedgerList({ pageNo: val })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.pageNo = 1
    },
    // 查询
    handleSearch () {
      const { forewarningType } = this.searchForm
      this.getWarningLedgerList({ reservoirAreaCode: 'MYTCLK', forewarningType })
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-btn {
  display: inline-block;
}
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
.mr10 {
  margin-right: 10px;
}
</style>
